import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles(
  'small-footer',
  ({
    palette: { grey, common },
    breakpoints: {
      up,
      values: { lg },
    },
  }) => ({
    footer: {
      background: grey[800],
      color: common.white,
    },

    footerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: `${lg}px`,
      margin: '0 auto',
      flexDirection: 'column-reverse',
      alignItems: 'center',
      [up(720)]: {
        flexDirection: 'row',
      },
    },

    logo: {
      display: 'none',
      [up(720)]: {
        display: 'block',
      },
    },
    logoEmployer: {
      display: 'none',
      [up(720)]: {
        height: '52.5px',
        display: 'flex',
        alignItems: 'center',
        marginRight: '12px',
      },
    },

    copyright: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 0,
      lineHeight: 1.5,
      fontSize: '0.75rem',
      marginBottom: '1rem',
      [up(720)]: {
        marginBottom: 0,
        marginLeft: '1rem',
      },
    },

    links: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      listStyleType: 'none',
      fontSize: '0.75rem',
      color: common.white,
      margin: '1rem 1.5rem 1rem -1rem',
      lineHeight: 1.5,

      '& li': {
        '&:after': {
          content: '"|"',
          padding: '0 0.5rem',
        },
        '&:last-child:after': {
          display: 'none',
        },
      },
      [up(720)]: {
        margin: '0 1.5rem 0 0',
      },
    },
  }),
);

export default useStyles;
